export default __webpack_public_path__ + "static/media/container.d969f7ef.svg";